import { useTypedSelector } from '@Features/store';
import { FlexLayout, GridLayout } from '@Styled/utilities';
import React from 'react';
import { FlexLayoutWrapper, Text, Title, Info } from './InvoicesCard';

/**
 * Purchase invoice items. Legacy purchases carry `courses` (with their
 * classroom); standalone-course and bundle purchases carry their own item
 * arrays. Prices shown are the products' current prices — the amount
 * actually paid is the invoice's own price field.
 */
const CourseCard = () => {
	const { currentEntity } = useTypedSelector((state) => state.Invoices);

	const courses = currentEntity?.courses ?? [];
	const standaloneCourses = currentEntity?.standaloneCourses ?? [];
	const bundles = currentEntity?.bundles ?? [];

	return (
		<FlexLayoutWrapper flexDirection="column">
			{courses.length > 0 && (
				<>
					<Title>Course</Title>
					<GridLayout gridTemplateColumns="2fr repeat(2, 1fr)">
						{courses.map((_) => {
							return (
								<React.Fragment key={_?.id}>
									<FlexLayout flexDirection="column" gridGap="3.125rem">
										<Text> Name </Text>
										<Info> {_?.name} </Info>
									</FlexLayout>
									<FlexLayout flexDirection="column" gridGap="3.125rem">
										<Text> Price </Text>
										<Info> {_?.price} </Info>
									</FlexLayout>
									<FlexLayout flexDirection="column" gridGap="3.125rem">
										<Text> Classroom </Text>
										<Info> {_?.classroom?.title} </Info>
									</FlexLayout>
								</React.Fragment>
							);
						})}
					</GridLayout>
				</>
			)}
			{standaloneCourses.length > 0 && (
				<>
					<Title>Standalone Course</Title>
					<GridLayout gridTemplateColumns="2fr 1fr">
						{standaloneCourses.map((_) => {
							return (
								<React.Fragment key={_?.id}>
									<FlexLayout flexDirection="column" gridGap="3.125rem">
										<Text> Name </Text>
										<Info>
											{_?.label ? `${_?.title} (${_?.label})` : _?.title}
										</Info>
									</FlexLayout>
									<FlexLayout flexDirection="column" gridGap="3.125rem">
										<Text> Price </Text>
										<Info> {_?.price} </Info>
									</FlexLayout>
								</React.Fragment>
							);
						})}
					</GridLayout>
				</>
			)}
			{bundles.length > 0 && (
				<>
					<Title>Bundle</Title>
					<GridLayout gridTemplateColumns="2fr 1fr">
						{bundles.map((_) => {
							return (
								<React.Fragment key={_?.id}>
									<FlexLayout flexDirection="column" gridGap="3.125rem">
										<Text> Name </Text>
										<Info>
											{_?.label ? `${_?.title} (${_?.label})` : _?.title}
										</Info>
									</FlexLayout>
									<FlexLayout flexDirection="column" gridGap="3.125rem">
										<Text> Price </Text>
										<Info> {_?.price} </Info>
									</FlexLayout>
								</React.Fragment>
							);
						})}
					</GridLayout>
				</>
			)}
		</FlexLayoutWrapper>
	);
};

export default CourseCard;
